module.exports = __webpack_public_path__ + "static/media/Pickup.eb763212.png";